<div class="modal-log-container">
  <div class="modal-log-header">
    <h2 class="modal-log-title">Logs</h2>
    <button class="btn-fechar-mobile" (click)="fechar()" aria-label="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-log-content">
    @if (logs.length === 0) {
      <p class="logs-empty">Nenhum log encontrado.</p>
    } @else {
      <div class="logs-list">
        @for (log of logs; track log.id ?? $index) {
          <article class="log-item">
            <header class="log-header">
              <div class="log-acao-container">
                <div class="log-icon">
                  <img
                    [src]="getImagemAcao(log.acao)"
                    [alt]="log.acao"
                  />
                </div>
                <span class="log-acao">
                  {{ formatarAcao(log.acao) }}
                </span>
              </div>
              <div class="log-data-container">
                <span class="log-data">
                  {{ formatarData(log.dataAlteracao) }}
                </span>
                <span class="log-hora">
                  {{ formatarHora(log.dataAlteracao) }}
                </span>
              </div>
            </header>
            <div class="log-separator"></div>
            <p
              class="log-descricao"
              [innerHTML]="formatarDescricao(log)">
            </p>
          </article>
        }
      </div>
    }
  </div>
</div>
